import React from 'react';

import {
  createDictionaryService,
  deleteDictionaryService,
  updateDictionaryService,
} from '@mygpt/app/dictionary/services';

export const useDictionaryMethods = () => {
  const [loading, setLoading] = React.useState(false);

  const create = React.useCallback(async (params: Parameters<typeof createDictionaryService>[0]) => {
    setLoading(true);
    return createDictionaryService(params).finally(() => {
      setLoading(false);
    });
  }, []);

  const _delete = React.useCallback(async (params: Parameters<typeof deleteDictionaryService>[0]) => {
    setLoading(true);
    return deleteDictionaryService(params).finally(() => {
      setLoading(false);
    });
  }, []);

  const update = React.useCallback(async (params: Parameters<typeof updateDictionaryService>[0]) => {
    setLoading(true);
    return updateDictionaryService(params).finally(() => {
      setLoading(false);
    });
  }, []);

  return {
    loading,
    createDictionary: create,
    deleteDictionary: _delete,
    updateDictionary: update,
  };
};
